import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import type {
  RdClientPayload,
  RdProposal,
} from '@/services/quotes/rd-equipamentos/types';
import { useMutation } from '@tanstack/react-query';

type UpdateRdClientParams = {
  proposalId: string;
  payload: RdClientPayload;
};

/** Atualiza os dados do cliente de uma proposta RD Equipamentos existente (Step 1 — Cliente, modo edição). */
export function useUpdateRdClient() {
  return useMutation<RdProposal, Error, UpdateRdClientParams>({
    mutationKey: ['quotes', 'update', 'rd-equipamentos', 'client'],
    mutationFn: async ({ proposalId, payload }) => {
      const response = await rdEquipamentosService.updateClient(
        proposalId,
        payload
      );
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao atualizar cliente');
      }

      return response.data;
    },
  });
}
